<script>
  import * as d3 from "d3";
  import { onMount } from "svelte";

  export let evictions = [];

  var geojson;
  let zip_geojson;
  var legend;
  let svg;

  // $:console.log(evictions[0])

  let canvas = { height: 250, width: window.innerWidth * 0.95, margin: 25 };

  // let bins = d3.bin().thresholds(40)(evictions)
  // console.log(d3.extent(evictions, d => new Date(d.filingdate)))

  let xScale = d3
    .scaleTime()
    .domain(d3.extent(evictions, (d) => new Date(d.filingdate)))
    .range([canvas.margin, canvas.width - canvas.margin]);

  let month_extent = d3.extent(evictions, (d) => new Date(d.filingdate));
  let month_bins = d3.timeWeeks(
    d3.timeWeek.offset(month_extent[0], -1),
    d3.timeWeek.offset(month_extent[1], 1)
  );

  let binByMonth = d3
    .bin()
    .value((d) => new Date(d.filingdate))
    .thresholds(month_bins);

  let binned_evictions = binByMonth(evictions);

  // console.log(binned_evictions)

  let yScale = d3
    .scaleLinear()
    .domain([0, d3.max(binned_evictions, (d) => d.length)])
    .range([canvas.height - canvas.margin, canvas.margin]);

  var lineInterpolate = d3
    .line()
    .x(function (d) {
      return xScale(new Date(d.date));
    })
    .y(function (d) {
      return yScale(d.value);
    });

  // Append historical chart title
  // svg.append("text")
  // 	.attr("x", 29)
  // 	.attr("y", 0)
  // 	.attr("alignment-baseline", "hanging")
  // 	.attr("font", "sans-serif")
  // 	.attr("font-size", 12)
  // 	.text(`Eviction Counts by Week`)

  onMount(() => {
    svg = d3.select("#history");
    svg.attr("height", canvas.height).attr("width", canvas.width);
    svg
      .append("text")
      .attr("x", 29)
      .attr("y", 0)
      .attr("alignment-baseline", "hanging")
      .attr("font", "sans-serif")
      .attr("font-size", 12)
      .text(
        `*New Fulton County Data no longer available after September of 2020.`
      );

    // Add y axis
    svg
      .append("g")
      .attr("transform", `translate(${canvas.margin}, 0)`)
      .call(
        d3
          .axisRight(yScale)
          .ticks(4)
          .tickFormat(d3.format(".0s"))
          .tickSize(canvas.width - canvas.margin * 2)
      )
      .call((g) => g.select(".domain").remove())
      .call((g) =>
        g
          .selectAll(".tick:not(:first-of-type) line")
          .attr("stroke-opacity", 0.2)
          .attr("stroke-dasharray", "2,2")
      )
      .call((g) => g.selectAll(".tick text").attr("x", 4).attr("dy", -4));

    // Add bar for each bin
    svg
      .selectAll(".bar")
      .data(binned_evictions)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("x", (d) => xScale(d.x0))
      .attr("width", (d) => xScale(d.x1) - xScale(d.x0) - 1)
      .attr("y", (d) => yScale(d.length))
      .attr("height", (d) => canvas.height - canvas.margin - yScale(d.length))
      .attr("fill", "steelblue");

    // Add x axis
    svg
      .append("g")
      .attr("transform", `translate(0, ${canvas.height - canvas.margin})`)
      .call(d3.axisBottom(xScale));
  });
</script>

<svg id="history" />
